// extracted by mini-css-extract-plugin
export default {"wrap":"FeedPage_wrap__IYsDH","observe_div":"FeedPage_observe_div__sj1UD"};